import React from 'react'
import { GroupList } from './list/page'

export const GroupsPage = (): JSX.Element => {
  return <GroupList />
}
